import { render, staticRenderFns } from "./addUpdateService.vue?vue&type=template&id=1011e058"
import script from "./addUpdateService.vue?vue&type=script&lang=js"
export * from "./addUpdateService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports